import { useState } from 'react'
import constate from 'constate'
import { TComparedKeyword } from '../definitions'

const useKeywordsState = () => {
  const [keywords, setKeywords] = useState<string>('')
  const [submittedKeywords, setSubmittedKeywords] = useState<string>('')
  const [comparedKeywords, setComparedKeywords] = useState<TComparedKeyword[]>([])
  const [includeStemmingSearch, setIncludeStemmingSearch] = useState<boolean>(true)

  return {
    keywords,
    setKeywords,
    submittedKeywords,
    setSubmittedKeywords,
    comparedKeywords,
    setComparedKeywords,
    includeStemmingSearch,
    setIncludeStemmingSearch
  }
}

export const [KeywordsStateProvider, useKeywordsStateContext] = constate(useKeywordsState)
